import React, { useState, useEffect } from 'react'
import Login from '../Auth/Login'
import { Link, useHistory } from 'react-router-dom';
import Cookies from "js-cookie";
import { CountriesAPI, OrderAPI } from '../../lib/API'
import { emptyBasket } from '..';
import Utils from '../../lib/Utils';
import Select from 'react-select';
import { CoinBase } from '../../lib/CoinBase';
import { GIFTSWAP_BENEFIT } from '../../Env';

async function getBasketItems() {
  let cart = await Cookies.get("giftSwapCart");
  if (!cart) return [];
  else return JSON.parse(cart);
}

const Checkout = () => {

  const history = useHistory();
  const [items, setItems] = useState();
  const [phoneRequired, setPhoneRequired] = useState(false);
  const [order, setOrder] = useState({
    products: [],
    sum: 0,
    token: localStorage.getItem('currency') || 'USDT',
    email: null,
    phone: null,
    country: null
  });

  const [loggedIn, setLoggedIn] = useState(false);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState();
  const [rate, setRate] = useState();

  const setTokenChoice = ({ target }) => {
    localStorage.setItem('currency', target.value);
    setOrder({ ...order, token: target.value })
  }

  useEffect(() => {
    if (!items || items.length == 0) return;
    const totalEuro = items.reduce((sum, x) => sum + x.euroPrice * x.quantity * GIFTSWAP_BENEFIT, 0);
    CoinBase.GetRate(order.token, "EUR")
      .then((rt) => {
        setTotal(totalEuro / rt);
        setRate(rt);
      })
      .catch(console.log);

  }, [items, order.token])

  useEffect(() => {
    if (Utils.CheckUser()) {
      const user = Utils.GetUser();
      order.email = user.email;
      order.phone = user.phone;
      if (user.country)
        order.country = { ...user.country, label: user.country.name, value: user.country.id };
      setLoggedIn(true)
    }

    getBasketItems()
      .then((items) => {
        if (items.length == 0) {
          history.push('/')
        }
        setPhoneRequired(items.find(i => i.phoneRequired))
        const sum = items.reduce((s, p) => s += p.total, 0);
        setItems(items);
        order.sum = sum;
      })

    CountriesAPI.GetCountries()
      .then(({ data }) => {
        if (!order.country)
          order.country = { ...data[0], value: data[0].id, label: data[0].name };
        setCountries(data.map((c) => { return { ...c, value: c.id, label: c.name } }));
      })
      .finally(() => {
        setOrder({ ...order })
      });

  }, [])

  const checkout = (e) => {
    e.preventDefault();
    const user = Utils.GetUser();
    user.phone = order.phone;
    user.country = order.country;
    Utils.SaveUser(user);
    order.products = items.map((item) => {
      return {
        variantId: item.variantId,
        productId: item.id,
        quantity: item.quantity,
        price: item.price,
        currency: item.currency,
        total: item.quantity * item.price * GIFTSWAP_BENEFIT,
        servicenumber: item.servicenumber
      }
    });

    setLoading(true);
    OrderAPI.Checkout(order)
      .then(({ data: link }) => {
        window.location.href = link
        emptyBasket();
      })
      .catch(() => {
        alert("An error occured");
        setLoading(false)
      })
  }

  const setItemServiceNumber = (_item, servicenumber) => {
    const item = items.find(i => i.productId == _item.productId);
    item.servicenumber = servicenumber;
    setItems([...items])
  }

  const selectCountry = (country) => {
    setOrder({ ...order, country })
  }

  const changeEmail = ({ target }) => {
    setOrder({ ...order, email: target.value })
  }

  const changePhone = ({ target }) => {
    setOrder({ ...order, phone: target.value })
  }

  const itemTotal = (item) => {
    return ((item.euroPrice * item.quantity * GIFTSWAP_BENEFIT) / rate)
  }

  return (
    <>
      <div className="products-search ">
        <h3>Checkout</h3>
      </div>

      <div className="cart">
        <div className="container row">
          <div className="col-lg-7">
            <h5>Order details</h5>

            <table className="items">
              <thead>
                <tr>
                  <td colspan="3">Product(s)</td>
                  <td>Quantity</td>
                  <td>Price</td>
                </tr>
              </thead>
              <tbody>
                {items && items.map((item, i) => (
                  <>
                    <tr key={i}>
                      <td colspan="3">
                        <div className="d-flex align-items-center">
                          <img className="mb-0" src={item.urlImage} alt={item.fullName} />
                          <h6 style={{ flex: 1 }}>{item.fullName}</h6>
                        </div>
                      </td>
                      <td>
                        <p>{item.quantity}</p>
                      </td>
                      <td>
                        {rate && <p>{itemTotal(item).toFixed(4)} {order.token}</p>}
                      </td>
                    </tr>
                    {(item.snRequired) && (
                      <tr className="servicenumber-row">
                        <td colSpan="5">
                          <div className="d-flex">
                            <div className="d-flex align-items-center" style={{ flex: 1 }}>
                              <h5 className="mb-0">Service number</h5>
                              <div style={{ flex: 1, marginLeft: 20 }}>
                                <input className="form-control" onChange={(e) => setItemServiceNumber(item, e.target.value)} required />
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </table>
            <div className="amoutdue mb-5">
              {total != undefined && <p>Amount Due <span>{total.toFixed(4)} {order.token}</span></p>}
            </div>

          </div>
          <div className={"col-lg-5 d-flex flex-column justify-content-center"}>
            {!loggedIn ? (
              <>
                <Login relaodOnLogin={true} header={false} h100={false} message={'Login to pay with your account balance, receive rewards, and more!'} />
                <div className="btns">
                  <p className="text-center py-4 ">Are you a new user?</p>
                  <Link to="/auth"><button className="btn-grey  w-100">Create account</button></Link>
                </div>
              </>
            ) : (
              <>
                <h3 className="mb-5">Ready to checkout ?</h3>
                <div className="form-group">
                  <label for="email">Email Address</label>
                  <input className="form-control form-control-lg" type="email" placeholder="example@email.com" defaultValue={order.email} onChange={changeEmail} />
                </div>
                <div className="form-group">
                  <label>Country</label>
                  <div className="row">
                    <div className="col-9">
                      {countries && countries.length > 0 ?
                        <Select className="select select-lg country-select" onChange={selectCountry} options={countries} value={order.country}></Select>
                        :
                        <Select></Select>
                      }
                    </div>
                  </div>
                </div>
                {phoneRequired && (
                  <div className="form-group">
                    <label>Phone number</label>
                    <div className="row">
                      <div className="col-3">
                        <div className="phonecode" >
                          {order.country && <CountryPhoneCode country={order.country} />}
                        </div>
                      </div>
                      <div className="col-9">
                        <input type="text" className="form-control form-control-lg" onChange={changePhone} defaultValue={order.phone} />
                      </div>
                    </div>
                  </div>
                )}
                <div className="form-group">
                  <label for="email">Choose payment token</label>
                  <div className="row justify-content-center">
                    <div className="col-4">
                      <button type="button" className={"mb-3 btn w-100 btn-black-outline" + (order.token == 'USDT' ? ' active' : '')} value={'USDT'}
                        onClick={setTokenChoice}>USDT</button>
                    </div>
                    <div className="col-4">
                      <button type="button" className={"mb-3 btn w-100 btn-black-outline" + (order.token == 'USDC' ? ' active' : '')} value={'USDC'}
                        onClick={setTokenChoice}>USDC</button>
                    </div>
                    <div className="col-4">
                      <button type="button" className={"mb-3 btn w-100 btn-black-outline" + (order.token == 'DAI' ? ' active' : '')} value={'DAI'}
                        onClick={setTokenChoice}>DAI</button>
                    </div>
                    <div className="col-4">
                      <button type="button" className={"mb-3 btn w-100 btn-black-outline" + (order.token == 'BNB' ? ' active' : '')} value={'BNB'}
                        onClick={setTokenChoice}>BNB</button>
                    </div>
                    <div className="col-4">
                      <button type="button" className={"mb-3 btn w-100 btn-black-outline" + (order.token == 'BUSD' ? ' active' : '')} value={'BUSD'}
                        onClick={setTokenChoice}>BUSD</button>
                    </div>
                  </div>
                </div>
                <button className="btn-yellow w-100" type="button" onClick={checkout} disabled={loading}>Go to Payment</button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Checkout


const CountryPhoneCode = ({ country }) => {
  const svgPath = `https://raw.githubusercontent.com/mledoze/countries/master/data/${country.code.toLowerCase()}.svg`
  return (
    <>
      <div className="country-flag">
        <img className="country-flag-img" src={svgPath} />
      </div>
      {country.phonePrefix}
    </>
  )
}